/**
 * Badge Component
 * Small label for highlighting information
 */

import React, { forwardRef } from 'react';
import { Box } from './Box';
import { useTheme } from '../theme';

/**
 * Badge Component
 * A small label for highlighting information
 * 
 * @example
 * <Badge colorScheme="green">Success</Badge>
 * <Badge variant="outline" colorScheme="blue">New</Badge>
 */
export const Badge = forwardRef(({
  variant = 'subtle',
  colorScheme = 'gray',
  size,
  children,
  ...props
}, ref) => {
  const theme = useTheme();
  const styles = theme?.components?.Badge || {};

  // Get variant styles
  const variantStyles = styles.variants?.[variant]?.({ colorScheme }) || {};
  const baseStyles = styles.baseStyle || {};

  return (
    <Box
      ref={ref}
      as="span"
      display="inline-block"
      whiteSpace="nowrap"
      verticalAlign="middle"
      {...baseStyles}
      {...variantStyles}
      {...props}
    >
      {children}
    </Box>
  );
});

Badge.displayName = 'Badge';

export default Badge;
